import { findCategoryById } from 'app/functions';
import { HOT_YOTER_ALL_CATEGORIES_ID, HOT_YOTER_ALL_GROUPS_ID } from '../constants';

export const HOT_YOTER_BENEFITS_SEARCH_FIELDS = ['benefit_title'];

//'category',

export const buildHotYoterBenefitGroupIds = (benefitsGroups = [], selectedGroupId) => {
    if (selectedGroupId !== HOT_YOTER_ALL_GROUPS_ID) {
        return [selectedGroupId];
    }

    return benefitsGroups
        .map((group) => group.id)
        .filter((id) => id != null);
};

export const HOT_YOTER_SEARCH_LENGTH_THRESHOLD = 2;

export const normalizeHotYoterTextQuery = (query = '') => {
    const trimmedQuery = String(query).trim();

    return trimmedQuery.length >= HOT_YOTER_SEARCH_LENGTH_THRESHOLD
        ? trimmedQuery
        : '';
};

export const buildHotYoterSearchParams = ({
    benefitsGroups = [],
    selectedGroupId,
    selectedCategoryId,
    textQuery = '',
    page = 1,
}) => ({
    benefitGroupIds: buildHotYoterBenefitGroupIds(benefitsGroups, selectedGroupId),
    selectedCategoryId,
    textQuery: normalizeHotYoterTextQuery(textQuery),
    page,
});

export const buildHotYoterBenefitsSearchUrl = ({
    benefitGroupIds = [],
    selectedCategoryId,
    textQuery = '',
    page = 1,
}) => {
    const searchParams = new URLSearchParams();
    searchParams.set('showHiddenBenefits', 'false');

    if (page > 1) {
        searchParams.set('page', String(page));
    }

    HOT_YOTER_BENEFITS_SEARCH_FIELDS.forEach((field) => {
        searchParams.append('fields', field);
    });

    benefitGroupIds.forEach((groupId) => {
        searchParams.append('benefitGroups', String(groupId));
    });

    if (
        selectedCategoryId != null
        && String(selectedCategoryId) !== String(HOT_YOTER_ALL_CATEGORIES_ID)
    ) {
        searchParams.append('category', String(selectedCategoryId));
    }

    const normalizedTextQuery = normalizeHotYoterTextQuery(textQuery);

    // Same role as category_page's textQuery — search API expects `query`.
    if (normalizedTextQuery) {
        searchParams.set('query', normalizedTextQuery);
    }

    return `/search/api/benefits?${searchParams.toString()}`;
};

export const filterActiveHotYoterBenefits = (records = []) => records.filter((record) => (
    record.active === true
    && record.is_expired === false
    && record?.imagePath?.trim?.()
));

export const getHotYoterSearchRecords = (searchData) => (
    searchData?.benefits?.records
    ?? searchData?.records
    ?? []
);

export const getHotYoterSearchMetadata = (searchData) => (
    searchData?.benefits?.metadata
    ?? searchData?.benefits?.metaData
    ?? searchData?.metadata
    ?? searchData?.metaData
    ?? {}
);

export const getHotYoterCategoryFilterValues = (searchData) => {
    const filters = getHotYoterSearchMetadata(searchData).filters ?? [];
    const categoryFilter = filters.find((filter) => filter.inputName === 'category');

    return categoryFilter?.values ?? [];
};

export const buildHotYoterAvailableCategories = ({
    categoryIds = [],
    categories = [],
    allCategoriesLabel = 'הכל',
}) => {
    const availableCategories = [
        { id: HOT_YOTER_ALL_CATEGORIES_ID, title: allCategoriesLabel },
    ];
    const seenIds = new Set([String(HOT_YOTER_ALL_CATEGORIES_ID)]);

    categoryIds.forEach((categoryId) => {
        const normalizedId = String(categoryId);

        if (seenIds.has(normalizedId)) {
            return;
        }

        seenIds.add(normalizedId);

        const categoryData = findCategoryById(categories, categoryId);

        availableCategories.push(categoryData ? {
            id: Number(categoryData.id),
            title: categoryData.title ?? categoryData.name ?? categoryData.text ?? '',
            media_path: categoryData.media_path ?? categoryData.sliderMediaPath ?? null,
        } : {
            id: Number(categoryId),
            title: String(categoryId),
        });
    });

    return availableCategories;
};
